"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyWebShareCommand = exports.SurveyManagementMenuCommand = exports.SurveyReopenCommand = exports.SurveyEditCommand = exports.SurveyCloseCommand = exports.SurveyDeleteCommand = exports.SurveyManagementCommands = void 0;
const Command_1 = require("../../_shared/commands/Command");
var SurveyManagementCommands;
(function (SurveyManagementCommands) {
    SurveyManagementCommands["Delete"] = "survey/delete";
    SurveyManagementCommands["Close"] = "survey/close";
    SurveyManagementCommands["Menu"] = "survey/management/menu";
    SurveyManagementCommands["WebShare"] = "survey/share/web";
    SurveyManagementCommands["Edit"] = "survey/management/edit";
    SurveyManagementCommands["ReOpen"] = "survey/reopen";
})(SurveyManagementCommands = exports.SurveyManagementCommands || (exports.SurveyManagementCommands = {}));
function SurveyDeleteCommand(surveyId) {
    const data = {
        command: SurveyManagementCommands.Delete,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyDeleteCommand = SurveyDeleteCommand;
function SurveyCloseCommand(surveyId) {
    const data = {
        command: SurveyManagementCommands.Close,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyCloseCommand = SurveyCloseCommand;
function SurveyEditCommand(surveyId) {
    const data = {
        command: SurveyManagementCommands.Edit,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyEditCommand = SurveyEditCommand;
function SurveyReopenCommand(surveyId) {
    const data = {
        command: SurveyManagementCommands.ReOpen,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyReopenCommand = SurveyReopenCommand;
function SurveyManagementMenuCommand(surveyId) {
    const data = {
        command: SurveyManagementCommands.Menu,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyManagementMenuCommand = SurveyManagementMenuCommand;
function SurveyWebShareCommand(surveyId, confirmedCreate) {
    const data = {
        command: SurveyManagementCommands.WebShare,
        surveyId,
        confirmedCreate,
    };
    return new Command_1.Command(data);
}
exports.SurveyWebShareCommand = SurveyWebShareCommand;
//# sourceMappingURL=SurveyManagementCommands.js.map